/**
 * 자동 구축의 표준 표식 규격과 촬영 규칙 — 고객 문구와 가이드 고도 표가 모두 이 값에서 정해진다(mapping-request
 * 「표준 표식 규격과 촬영 규칙」). 백엔드가 인식하는 표식 규격과 같아야 한다.
 */
import { truncateNumber } from "src/domains/shared/utils/truncateNumber";

const GCP_MARKER_SIDE_M = 0.7;

/**
 * 촬영 GSD 상한(cm) — 판이 사진에서 한 변 약 26 px 가 되는 값이고, 인식되는 모든 판에 하나다. 소수 첫째 자리까지만 둔다 —
 * 문구는 한 자리로 버려 보이므로, 둘째 자리가 있으면 문구와 고도 표가 서로 다른 값을 쓴다.
 */
export const GCP_GSD_LIMIT_CM = 2.7;

/** 인식이 크게 떨어지기 시작하는 판의 픽셀 수(한 변). */
const GCP_MARKER_FALLOFF_PX = 23;

const markerSideCm = Math.round(GCP_MARKER_SIDE_M * 100);
/** 표준 표식의 한 변(mm) — 값이 바뀌면 그 크기의 인쇄 파일(`dronesquare-v1-<mm>mm.*`)이 `public/` 에 있어야 한다. */
export const GCP_MARKER_SIDE_MM = markerSideCm * 10;
const falloffGsdCm = markerSideCm / GCP_MARKER_FALLOFF_PX;

/**
 * 문구 변수 — 이 숫자가 든 문구를 그리는 호출부가 `t(key, GCP_MARKER_COPY_VARIABLES)` 로 넘긴다. 앱 전역 i18n 의 기본 변수로
 * 두면 모든 i18next 인스턴스가 이 모듈을 알아야 하고, 빠뜨린 인스턴스는 `{{…}}` 를 경고 없이 그린다.
 */
export const GCP_MARKER_COPY_VARIABLES = {
  gcpMarkerSideCm: String(markerSideCm),
  gcpMarkerSideMm: String(GCP_MARKER_SIDE_MM),
  gcpGsdLimitCm: truncateNumber(GCP_GSD_LIMIT_CM, 1),
  gcpGsdFalloffCm: truncateNumber(falloffGsdCm, 1),
} as const;
